import { PropsWithChildren } from 'react';

import { css } from '@compiled/react';
import { FormattedMessage } from 'react-intl';

/**
 * @deprecated use Headings component instead
 */
export const SubHeading = ({ children }: PropsWithChildren) => (
	<p css={subheadingCss}>{children}</p>
);

const subheadingCss = css({
	margin: '8px 0 16px',
	textAlign: 'center',
});

export const FreeForTenUsersText = () => (
	<FormattedMessage
		id="signupForm.accountCreation.subHeaderText"
		defaultMessage="It’s free for up to 10 users - no credit card needed."
	/>
);

export const FreeForThreeCreatorsText = () => (
	<FormattedMessage
		id="signupForm.accountCreation.subHeaderText.jpd.freeForThreeCreators"
		defaultMessage="It's free for up to 3 creators - no credit card needed."
	/>
);

export const FreeToGetStartedText = () => (
	<FormattedMessage
		id="signupForm.accountCreation.subHeaderText.jpd.freeToGetStarted"
		defaultMessage="It's free to get started - no credit card needed."
	/>
);

export const PickUpWhereYouLeftOffText = () => (
	<FormattedMessage
		id="return-to-product-modal.header.text"
		defaultMessage="Pick up where you left off."
	/>
);

export const SitesAreSharedSpacesText = () => (
	<FormattedMessage
		id="LoomTemplate.loggedInHero.subheader"
		defaultMessage="Sites are shared spaces to organize work, teams, and projects."
	/>
);

export const WorkspacesAreWhereText = () => (
	<FormattedMessage
		id="signup.serviceCollection.newUser"
		defaultMessage="Workspaces are where people organize teams, work, and projects."
	/>
);

export const YourPlanIncludesText = () => (
	<FormattedMessage
		id="signup.serviceCollection.newUser"
		defaultMessage="Your plan includes Jira Service Management, Customer Service Management, Assets, and Rovo. Free for up to 3 agents."
	/>
);
